import '../scss/foundation.scss';
import '../scss/main.scss';

// Either import everything
//import 'foundation-sites;

// Or import individual modules
/**/

import 'foundation-sites/dist/js/plugins/foundation.core';

import 'foundation-sites/dist/js/plugins/foundation.dropdownMenu.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.keyboard.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.box.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.nest.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.mediaQuery';
import 'foundation-sites/dist/js/plugins/foundation.util.imageLoader';//
import 'foundation-sites/dist/js/plugins/foundation.util.motion';
import 'foundation-sites/dist/js/plugins/foundation.util.triggers';
import 'foundation-sites/dist/js/plugins/foundation.util.touch';
import 'foundation-sites/dist/js/plugins/foundation.equalizer';
import 'foundation-sites/dist/js/plugins/foundation.reveal';
import 'foundation-sites/dist/js/plugins/foundation.tabs.js';

import Accordions from './modules/Accordions';

//console.log('Entry Loaded');
document.addEventListener("DOMContentLoaded", function () {
	$(document).foundation();

	// mobile hamburger menu
	$('.hamburger').on('click', function (e) {
		$('.hamburger').toggleClass('is-active');
		$('.nav-menu-container').toggleClass('is-active');
		$('.menu-overlay-bg').toggleClass('is-active');
		if ($('.menu-text').text() == "Close") {
			$('.menu-text').text("Menu")
		} else {
			$('.menu-text').text("Close");
		}		
		e.preventDefault();
	});

	// zone b mobile sub menu
	$('.zone-b-link').click(function(e) {
		e.preventDefault();
		var aid = $(this).attr("href");
		$('html, body').animate({scrollTop: $(aid).offset().top-30},'slow');
		$('.hamburger').toggleClass('is-active');
		$('.nav-menu-container').toggleClass('is-active');
		$('.menu-overlay-bg').toggleClass('is-active');
		$('.menu-text').text("Menu");
	});	

	$('.menu-overlay-bg').click(function(e) {
		$('.hamburger').toggleClass('is-active');
		$('.nav-menu-container').toggleClass('is-active');
		$('.menu-overlay-bg').toggleClass('is-active');
		$('.menu-text').text("Menu");
	});		

	$('.nav-has-sub').on('click', function (e) {
		e.preventDefault();
		$('.nav-sub-menu').toggleClass('is-active');
		$('.nav-sub-menu').attr('aria-expanded','true');		
	});		

	$('#maincontent').on('click', function (e) {
		//e.preventDefault();
		$('.header').removeClass('search-is-open');
		$('.nav-menu-container').removeClass('is-active');
		$('.hamburger').removeClass('is-active');
		$('.menu-overlay-bg').removeClass('is-active');
		$('.nav-sub-menu').removeClass('is-active');
				
	});

    if ($('a').hasClass('disabled')){
        $('.disabled').attr('disabled', 'disabled');  
	}
	
	$('.disabled').on('click', function (e) {
		e.preventDefault();				
	});	


	// modal open
	$('.modal-link').on('click', function() {
		$('#video-modal').foundation('open');		     
        $('.embed-player').attr("src", $(this).attr('data-video-link'));
	});

	// reveal video close and stop
	$('.reveal-overlay').on('click', function (e) {
		$('.reveal-video iframe').attr('src', '');
		if (e.keyCode == 27) { 
			$('.reveal-video iframe').attr('src', '');
		}
	});
	$('.reveal-video .close-button').on('click', function (e) {
		$('.reveal-video iframe').attr('src', '');
	});
	$(document).on('keyup',function(evt) {
		if (evt.keyCode == 27) {
			$('.reveal-video iframe').attr('src', '');
		}
	});

	
	// accordions
	const accordion = new Accordions();
	accordion.init(); 	

	$('.acc-close').on('click', function (e) {
		e.preventDefault();
		$('.acc-link').removeClass('open');
		$('.zone-menu-link').removeClass('open');
		$('.acc-link').attr('aria-expanded','false');
	});

	$('.acc-link').click(function(e) {
		e.preventDefault();
		var accLink = $(this).attr('data-menu-link');
		if($('.acc-link').hasClass('open')){
			$('.zone-menu-link').removeClass('open');
			$('.zone-menu-link[data-menu-link = '+accLink+']').addClass('open');
			var aid = $(this).attr('href');
			$('html, body').animate({scrollTop: $('#'+accLink).offset().top-30},'slow');
		}else {
			$('.zone-menu-link').removeClass('open');
		}
	});
	$('.zone-menu-link').click(function(e) {
		e.preventDefault();
		var menuLink = $(this).attr('data-menu-link');
		var aid = $(this).attr("href");
		$('.acc-link').each(function() {
			if($($(this)).attr('data-menu-link') == menuLink){
				if($(this).hasClass('open')){
					$('.acc-link').removeClass('open');
					$('.acc-link').attr('aria-expanded','false');
					$('.zone-menu-link[data-menu-link = '+menuLink+']').removeClass('open');
				}else {
					$('.zone-menu-link').removeClass('open');
					$('.zone-menu-link[data-menu-link = '+menuLink+']').addClass('open');						
					$('.acc-link').removeClass('open');
					$('.acc-link').attr('aria-expanded','false');
					$('.acc-link[data-menu-link = '+menuLink+']').addClass('open');
					$('.acc-link[data-menu-link = '+menuLink+']').attr('aria-expanded','true');
					$('html, body').animate({scrollTop: $(aid).offset().top-30},'slow');
				}				
			}		
		});	
	});	

	$('.btn-zone-sub').click(function(e) {
		e.preventDefault();
		$(this).toggleClass('sub-open');
		$('.zone-user-content').toggleClass('sub-active');	
		if($(this).hasClass('sub-open')){
			$(this).attr('aria-expanded','true');
		}else {
			$(this).attr('aria-expanded','false');
		}			
	});	
	
});
